import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DepartmentDto } from '@core/models/department';
import { RegionModel } from '@core/models/region.model';
import { Observable } from 'rxjs';
import { DomainService } from '../domain.service';

@Injectable({
  providedIn: 'root'
})
export class RegionsNativeService {
  private _apiUrl: string = '';

  constructor(private readonly http: HttpClient,
    private _domainService: DomainService,
  ) {
    this._domainService.apiUrl$.subscribe((apiUrl: string) => {
      this._apiUrl = apiUrl;
    });
  }
  getRegions(params: {clientId: number}): Observable<RegionModel[]> {
    return this.http.get<RegionModel[]>(`${this._apiUrl}dispatcher/regions/${params.clientId}?format=json`)
  }

  getDepartments(params: {clientId: number}): Observable<DepartmentDto[]> {
    return this.http.get<DepartmentDto[]>(`${this._apiUrl}dispatcher/departments/${params.clientId}?format=json`)
  }
}
